import React, { useState, useEffect } from "react";
import { FaUsers } from "react-icons/fa";
import { BsFillBookmarkCheckFill } from "react-icons/bs";
import { PiBookOpenTextFill } from "react-icons/pi";
import SummaryApi from "../common/index"; // Adjust the import path based on your project structure
import { useNavigate } from "react-router-dom"; // ← ADD THIS LINE
import { encodeCourseId } from "../utils/encoder"; // Add this import
const InstructorDashboard = () => {
  const [dashboardCounts, setDashboardCounts] = useState({
    totalStudents: 0,
    totalCourses: 0,
    completedCourses: 0,
    ongoingCourses: 0
  });
  const [todaySchedule, setTodaySchedule] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);
  const [currentTime, setCurrentTime] = useState(new Date()); // State for real-time updates
const [startedClasses, setStartedClasses] = useState({});
const [classTimerStarted, setClassTimerStarted] = useState({});

  // Get instructor_id from sessionStorage or default as number
  const instructorId = parseInt(sessionStorage.getItem('instructor_id')) || 0;

  // Update current time every second for real-time seconds display
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer); // Cleanup on unmount
  }, []);

  // Extract start and end time from day-based time range string
  const extractTimeFromRange = (timeRange) => {
    if (!timeRange || timeRange === 'N/A') return { startTime: null, endTime: null };
    
    try {
      const [startTime, endTime] = timeRange.split('-');
      return { startTime: startTime.trim(), endTime: endTime.trim() };
    } catch (error) {
      return { startTime: null, endTime: null };
    }
  };

  // Get current day name (sunday, monday, etc.)
  const getCurrentDay = () => {
    const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    return days[new Date().getDay()];
  };

  // Capitalize first letter
  const capitalizeDay = (day) => {
    return day.charAt(0).toUpperCase() + day.slice(1);
  };

  // Calculate duration from time range
// Calculate duration from time range
// Calculate duration from time range - always show total class duration
const getDuration = (scheduleItem) => {
  const currentDay = getCurrentDay();
  const timeRange = scheduleItem[currentDay];
  
  if (!timeRange || timeRange === 'N/A') return 'N/A';
  
  const { startTime, endTime } = extractTimeFromRange(timeRange);
  
  if (!startTime || !endTime) return 'N/A';
  
  const start = new Date(`2000-01-01T${startTime}`);
  const end = new Date(`2000-01-01T${endTime}`);
  const diffMs = end - start;
  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
  
  // Always show total duration, not based on class status
  if (hours > 0 && minutes > 0) {
    return `${hours}h ${minutes}m`;
  } else if (hours > 0) {
    return `${hours}h`;
  } else {
    return `${minutes}m`;
  }
};
useEffect(() => {
  const saved = sessionStorage.getItem("classTimerStarted");
  if (saved) {
    setClassTimerStarted(JSON.parse(saved));
  }
}, []);

const getCountdownText = (scheduleItem) => {
  const currentDay = getCurrentDay();
  const timeRange = scheduleItem[currentDay];

  if (!timeRange || timeRange === "N/A")
    return <span className="text-gray-400 text-sm">N/A</span>;

  const { startTime, endTime } = extractTimeFromRange(timeRange);
  if (!startTime || !endTime)
    return <span className="text-gray-400 text-sm">N/A</span>;

  const now = currentTime;
  const today = new Date().toISOString().split("T")[0];
  const startDateTime = new Date(`${today}T${startTime}`);
  const endDateTime = new Date(`${today}T${endTime}`);

  const classKey = `${scheduleItem.course_id}_${scheduleItem.time_slot_id}`;
  const startedByInstructor = classTimerStarted[classKey];

  // BEFORE CLASS START
  if (now < startDateTime) {
    return (
      <div className="text-blue-600 dark:text-blue-400 text-sm">
        Starts in: {formatCountdown(startDateTime - now)}
      </div>
    );
  }

  // CLASS COMPLETED
  if (now >= endDateTime) {
    return (
      <div className="text-red-600 dark:text-red-400 text-sm">
        Completed
      </div>
    );
  }

  // AFTER START, BEFORE INSTRUCTOR CLICK
  if (!startedByInstructor) {
    return (
      <div className="text-yellow-600 dark:text-yellow-400 text-sm">
        Click "Start Class"
      </div>
    );
  }

  // ONGOING CLASS
  const remainingMs = endDateTime - now;
  return (
    <div className="text-green-600 dark:text-green-400 text-sm">
      Remaining: {formatCountdown(remainingMs)}
    </div>
  );
};


useEffect(() => {
  const saved = sessionStorage.getItem("classTimerStarted");
  if (saved) {
    setClassTimerStarted(JSON.parse(saved));
  }
}, []);


const hasClassStarted = (scheduleItem) => {
  const currentDay = getCurrentDay();
  const timeRange = scheduleItem[currentDay];
  
  if (!timeRange || timeRange === 'N/A') return false;
  
  const { startTime } = extractTimeFromRange(timeRange);
  if (!startTime) return false;
  
  const now = currentTime;
  const today = new Date().toISOString().split('T')[0];
  const startDateTime = new Date(`${today}T${startTime}`);
  
  return now >= startDateTime;
};

// Check if class has ended (for button state)
const hasClassEnded = (scheduleItem) => {
  const currentDay = getCurrentDay();
  const timeRange = scheduleItem[currentDay];
  
  if (!timeRange || timeRange === 'N/A') return true;
  
  const { endTime } = extractTimeFromRange(timeRange);
  if (!endTime) return true;
  
  const now = currentTime;
  const today = new Date().toISOString().split('T')[0];
  const endDateTime = new Date(`${today}T${endTime}`);
  
  return now >= endDateTime;
};
  // Check if class is ongoing
  const isClassOngoing = (scheduleItem) => {
    const currentDay = getCurrentDay();
    const timeRange = scheduleItem[currentDay];
    
    if (!timeRange || timeRange === 'N/A') return false;
    
    const { startTime, endTime } = extractTimeFromRange(timeRange);
    if (!startTime || !endTime) return false;

    const now = currentTime;
    const today = new Date().toISOString().split('T')[0];
    const startDateTime = new Date(`${today}T${startTime}`);
    const endDateTime = new Date(`${today}T${endTime}`);

    return now >= startDateTime && now < endDateTime;
  };


const handleStartClass = (scheduleItem) => {
  const classKey = `${scheduleItem.course_id}_${scheduleItem.time_slot_id}`;

  setClassTimerStarted(prev => {
    const updated = { ...prev, [classKey]: true };
    sessionStorage.setItem("classTimerStarted", JSON.stringify(updated));
    return updated;
  });

  const meetLink = "https://meet.google.com/abc-defg-hij";
  window.open(meetLink, "_blank", "noopener,noreferrer");
};


const hasInstructorStartedClass = (scheduleItem) => {
  const classKey = `${scheduleItem.course_id}_${scheduleItem.time_slot_id}`;
  return classTimerStarted[classKey] || false;
};

const formatCountdown = (ms) => {
  const h = Math.floor(ms / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  const s = Math.floor((ms % 60000) / 1000);

  // Include seconds in the format
  if (h > 0) return `${h}h ${m}m ${s}s`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
};


useEffect(() => {
  if (!todaySchedule || todaySchedule.length === 0) return;

  const updated = { ...classTimerStarted };
  let changed = false;

  todaySchedule.forEach((schedule) => {
    const classKey = `${schedule.course_id}_${schedule.time_slot_id}`;
    if (updated[classKey]) {
      if (hasClassEnded(schedule)) {
        delete updated[classKey];
        changed = true;
      }
    }
  });

  if (changed) {
    setClassTimerStarted(updated);
    sessionStorage.setItem("classTimerStarted", JSON.stringify(updated));
  }
}, [currentTime, todaySchedule, classTimerStarted]); // ← ADDED classTimerStarted HERE

  // Format time range from day-based field
  const formatTimeRange = (scheduleItem) => {
    const currentDay = getCurrentDay();
    const timeRange = scheduleItem[currentDay];
    
    if (!timeRange || timeRange === 'N/A') return 'N/A';
    
    const { startTime, endTime } = extractTimeFromRange(timeRange);
    
    if (!startTime || !endTime) return 'N/A';
    
    return `${formatTime(startTime)} - ${formatTime(endTime)}`;
  };

  // Fetch dashboard counts
  const fetchDashboardCounts = async () => {
    try {
      setError(null);
      
      const response = await fetch(SummaryApi.InstructorDashboardCounts.url, {
        method: SummaryApi.InstructorDashboardCounts.method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          instructor_id: instructorId
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.success !== false && data.data) {
        setDashboardCounts({
          totalStudents: data.data.total_students || 0,
          totalCourses: data.data.total_courses || 0,
       completedCourses: data.data.total_completed_courses || 0,
          ongoingCourses: data.data.ongoing_courses || 0
        });
      } else {
        console.warn('Dashboard counts API returned no data:', data.message || 'No data');
      }
    } catch (err) {
      console.error('Dashboard counts error:', err);
    }
  };

  // Fetch today's schedule
  const fetchTodaySchedule = async () => {
    try {
      setError(null);
      
      const response = await fetch(SummaryApi.instructortodayschedule.url, {
        method: SummaryApi.instructortodayschedule.method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          instructor_id: instructorId
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.success !== false && data.data && Array.isArray(data.data)) {
        const currentDay = getCurrentDay();
        const today = new Date();
        // Filter schedules to only include today's classes within the active date range
// In your fetchTodaySchedule function, after receiving data:
const filteredSchedules = data.data.filter(schedule => {
  const startDate = new Date(schedule.start_date);
  const endDate = new Date(schedule.end_date);
  const today = new Date();
  const isWithinDateRange = today >= startDate && today <= endDate;
  const hasTodaySchedule = schedule[currentDay] && schedule[currentDay] !== 'N/A';
  const hasValidCourseId = schedule.course_id && schedule.course_id !== 'NA==' && !isNaN(parseInt(schedule.course_id));
  
  return isWithinDateRange && hasTodaySchedule && hasValidCourseId;
}).map(schedule => ({
  ...schedule,
  course_id: parseInt(schedule.course_id) // Ensure it's a number
}));
        setTodaySchedule(filteredSchedules);
      } else {
        console.warn('Today schedule API returned no data:', data.message || 'No data');
        setTodaySchedule([]);
      }
    } catch (err) {
      console.error('Today schedule error:', err);
      setTodaySchedule([]);
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        await Promise.all([
          fetchDashboardCounts(),
          fetchTodaySchedule()
        ]);
      } catch (err) {
        console.error('Error fetching dashboard data:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = todaySchedule.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(todaySchedule.length / itemsPerPage);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Format time
  const formatTime = (timeString) => {
    if (!timeString) return 'N/A';
    try {
      const time = new Date(`2000-01-01T${timeString}`);
      return time.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    } catch (error) {
      return 'N/A';
    }
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    } catch (error) {
      return 'N/A';
    }
  };





const navigate = useNavigate(); // ← ADD THIS



const handleViewCurriculum = (scheduleItem) => {
  if (scheduleItem.course_id) {
    const { course_id, time_slot_id, batch_name } = scheduleItem;
    const encodedCourseId = encodeCourseId(course_id);
    
    navigate(
      `/instructor-panel/curriculum/${encodedCourseId}?time_slot_id=${
        time_slot_id
      }&batch_name=${encodeURIComponent(batch_name || "N/A")}`
    );
  }
};




  // Dynamic card data based on API response with fallback
  const cardData = [
    {
      title: "Total Students",
      value: dashboardCounts.totalStudents > 0 ? dashboardCounts.totalStudents.toString() : "N/A",
      icon: <FaUsers size={24} />,
      bg: "bg-[#69a4fb]",
    },
    {
      title: "Total Course",
      value: dashboardCounts.totalCourses > 0 ? dashboardCounts.totalCourses.toString() : "N/A",
      icon: <BsFillBookmarkCheckFill size={24} />,
      bg: "bg-[#70bcb9]",
    },
    {
      title: "Completed Course",
      value: dashboardCounts.completedCourses > 0 ? dashboardCounts.completedCourses.toString() : "N/A",
      icon: <PiBookOpenTextFill size={24} />,
      bg: "bg-[#fe9c68]",
    },
    {
      title: "Ongoing Courses",
      value: dashboardCounts.ongoingCourses > 0 ? dashboardCounts.ongoingCourses.toString() : "N/A",
      icon: <FaUsers size={24} />,
      bg: "bg-[#89b174]",
    },
    {
      title: "Active Students",
      value: dashboardCounts.totalStudents > 0 ? dashboardCounts.totalStudents.toString() : "N/A",
      icon: <BsFillBookmarkCheckFill size={24} />,
      bg: "bg-[#0085b5]",
    },
    {
      title: "Today's Sessions",
      value: todaySchedule.length > 0 ? todaySchedule.length.toString() : "N/A",  // ← FIXED: was 'todayCount'
      icon: <PiBookOpenTextFill size={24} />,
      bg: "bg-[#5abe36]",
    },
  ];

  // Loading state - only show spinner, no full page block
  if (loading) {
    return (
<div className="p-6 bg-gray-50 dark:bg-gray-900 min-h-screen transition-colors duration-300">
  <h2 className="text-2xl font-bold mb-4 text-[#1f4774] dark:text-white">
    Instructor Dashboard
  </h2>
        <div className="flex justify-center items-center py-12">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#1f4774] mx-auto mb-4"></div>
            <p className="text-[#1f4774] font-medium dark:text-gray-300">Loading dashboard...</p>
          </div>
        </div>
      </div>
    );
  }

  // Always show the main content, even with errors
  return (
<div className="p-6 bg-gray-50 dark:bg-gray-900 min-h-screen transition-colors duration-300">
  <h2 className="text-2xl font-bold mb-4 text-[#1f4774] dark:text-white">
    Instructor Dashboard
  </h2>

      {/* Cards - Reduced dimensions */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        {cardData.map((card, index) => (
   <div
  key={index}
  className={`rounded-xl shadow-md p-4 text-white ${card.bg} flex flex-col items-center transition-all duration-300 hover:shadow-lg transform hover:-translate-y-1 dark:shadow-gray-700`}
>

            <div className="mb-2 p-2 rounded-full text-white shadow-[0_0_10px_rgba(255,255,255,0.5)]">
              {card.icon}
            </div>
            <div className="text-base font-medium text-center leading-tight">
              {card.title}
            </div>
            <div className={`text-xl font-bold mt-1 ${card.value === 'N/A' ? 'text-gray-200' : ''}`}>
              {card.value}
            </div>
          </div>
        ))}
      </div>

      {/* Today's Schedule - Reduced dimensions */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-4 mb-8">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-[#1f4774] dark:text-white font-inter">Today's Schedule</h3>
          <span className="text-sm text-gray-500 dark:text-gray-400">
            {new Date().toLocaleDateString('en-US', {
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </span>
        </div>

        {todaySchedule.length > 0 ? (
          <div className="space-y-3">
            {currentItems.map((schedule, index) => (
              <div
                key={index}
                className="border border-gray-200 dark:border-gray-700 rounded-lg p-3 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors" 
              >
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-semibold text-[#1f4774] dark:text-white text-base">
                    {schedule.course_title || 'Untitled Course'}
                  </h4>
                  {/* <div className="flex items-center space-x-2">
                    <span className={`px-2 py-1 rounded-full text-sm font-medium ${
                      schedule.is_course_completed === 1 
                        ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300' 
                        : schedule.is_active === 0
                        ? 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300'
                        : 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300'
                    }`}>
                      {schedule.is_course_completed === 1 ? 'Completed' : schedule.is_active === 0 ? 'Inactive' : 'Active'}
                    </span>


                  </div> */}
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm text-gray-600 dark:text-gray-300 mb-2">
                  <div>
                    <div className="flex items-center mb-1">
                      <span className="w-2 h-2 bg-blue-500 rounded-full mr-2"></span>
                      Time: {formatTimeRange(schedule)}
                    </div>
<div className="flex items-center">
  <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
  Duration: {getDuration(schedule) || "N/A"}
</div>
                    <div className="flex items-center">
                      <span className="w-2 h-2 bg-yellow-500 rounded-full mr-2"></span>
                      {getCountdownText(schedule)}
                    </div>
                  </div>
                  <div>
                    <div className="flex items-center mb-1">
                      <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                      Students: {schedule.student_count || 'N/A'}
                    </div>
                    <div className="flex items-center">
                      <span className="w-2 h-2 bg-orange-500 rounded-full mr-2"></span>
                      Batch: {schedule.batch_name || 'N/A'}
                    </div>
                  </div>
                </div>

              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-8">
            <div className="text-gray-400 text-3xl mb-3">Calendar</div>
            <p className="text-gray-500 dark:text-gray-400 text-base mb-1">No classes scheduled for today</p>
            <p className="text-gray-400 dark:text-gray-500 text-sm">Check back later for updates</p>
          </div>
        )}
      </div>

      {/* Full Width Schedule Table with Pagination */}
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-4">
<h3 className="text-lg font-semibold mb-4 text-[#1F4774] dark:text-white font-inter text-center">
  Schedule Overview
</h3>
  <div className="overflow-x-auto">
    <table className="min-w-full text-sm text-gray-800 dark:text-gray-200 border-collapse">
      {/* Table Header */}
      <thead className="bg-[#1c3664] text-white text-center">
        <tr>
                    {/* <th className="px-3 py-3">S.no</th> */}
          <th className="px-3 py-3">Batch Name</th>
          <th className="px-3 py-3">Course Name</th>
          <th className="px-3 py-3">Day</th>
          <th className="px-3 py-3">Time</th>
          <th className="px-3 py-3">Instructor</th>
          <th className="px-3 py-3">Action</th>
          <th className="px-3 py-3 rounded-tr-lg flex items-center justify-center gap-1">
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
            Timer
          </th>
        </tr>
      </thead>

      {/* Table Body */}
      <tbody className="text-center align-middle">
        {currentItems.length > 0 ? (
          currentItems.map((activity, index) => {
            const currentDay = getCurrentDay();
            return (
              <tr key={index} className="border-t hover:bg-gray-50 dark:hover:bg-gray-700 transition">
      {/* <td className="px-3 py-3 font-medium align-middle text-gray-900 dark:text-gray-100">
  {index}
</td> */}
                <td className="px-3 py-3 font-medium align-middle text-gray-900 dark:text-gray-100">
                  {activity.batch_name || "N/A"}
                </td>
                <td className="px-3 py-3 align-middle text-gray-800 dark:text-gray-200">
                  {activity.course_title || "N/A"}
                </td>
                <td className="px-3 py-3 font-medium text-[#1c3664] dark:text-cyan-400 align-middle">
                  {capitalizeDay(currentDay)}
                </td>
                <td className="px-3 py-3 align-middle text-gray-700 dark:text-gray-300">
                  {formatTimeRange(activity)}
                </td>
                <td className="px-3 py-3 align-middle text-gray-700 dark:text-gray-300">
                  {activity.instructor_name || "N/A"}
                </td>
          
          <td className="px-3 py-3 align-middle">
  <div className="flex justify-center items-center gap-2">
<button
  onClick={() => handleStartClass(activity)}
  disabled={
    hasClassEnded(activity) ||          // CLASS COMPLETED
    !isClassOngoing(activity) ||       // NOT IN TIME RANGE
    hasInstructorStartedClass(activity) // ALREADY STARTED
  }
  className={`px-3 py-1 rounded text-sm font-medium transition-colors ${
    hasClassEnded(activity)
      ? "bg-gray-400 text-white cursor-not-allowed"  // COMPLETED
      : isClassOngoing(activity) && !hasInstructorStartedClass(activity)
      ? "bg-[#1c3664] text-white hover:bg-[#24477e]"
      : "bg-gray-300 text-gray-600 cursor-not-allowed"
  }`}
>
  {hasClassEnded(activity)
    ? "Completed"
    : hasInstructorStartedClass(activity)
    ? "Class Started"
    : "Start Class"}
</button>



    <button
      onClick={() => handleViewCurriculum(activity)}
      className="px-3 py-1 rounded text-sm font-medium hover:bg-blue-800 text-white bg-[#1C3664] flex items-center justify-center"
    >
      View
      <svg className="w-3 h-3 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
      </svg>
    </button>
  </div>
</td>
                <td className="px-1 py-3 align-middle text-sm">
                  {getCountdownText(activity)}
                </td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td
              colSpan="8"
              className="px-3 py-8 text-center text-gray-500 dark:text-gray-400 align-middle"
            >
              <div className="text-3xl font-semibold mb-2">List</div>
              <p>No schedule available for today</p>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>

  {/* Pagination */}
  {todaySchedule.length > 0 && totalPages > 1 && (
    <div className="flex items-center justify-between mt-4">
      <div className="text-sm text-gray-700 dark:text-gray-300">
        Showing {indexOfFirstItem + 1} to{" "}
        {Math.min(indexOfLastItem, todaySchedule.length)} of{" "}
        {todaySchedule.length} entries
      </div>
      <div className="flex items-center space-x-2">
        <button
          onClick={handlePrevPage}
          disabled={currentPage === 1}
          className={`px-3 py-1 rounded border text-sm font-medium transition-colors ${
            currentPage === 1
              ? "bg-gray-200 text-gray-500 cursor-not-allowed dark:bg-gray-700 dark:text-gray-400"
              : "bg-white border-gray-300 hover:bg-gray-50 text-gray-700 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-600"
          }`}
        >
          Previous
        </button>

        <div className="flex items-center space-x-1">
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((number) => (
            <button
              key={number}
              onClick={() => paginate(number)}
              className={`px-3 py-1 rounded text-sm font-medium transition-colors ${
                currentPage === number
                  ? "bg-[#1c3664] text-white"
                  : "bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-600"
              }`}
            >
              {number}
            </button>
          ))}
        </div>

        <button
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
          className={`px-3 py-1 rounded border text-sm font-medium transition-colors ${
            currentPage === totalPages
              ? "bg-gray-200 text-gray-500 cursor-not-allowed dark:bg-gray-700 dark:text-gray-400"
              : "bg-white border-gray-300 hover:bg-gray-50 text-gray-700 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-600"
          }`}
        >
          Next
        </button>
      </div>
    </div>
  )}

  {todaySchedule.length === 0 && (
    <div className="flex flex-col items-center justify-center h-48">
      <div className="text-gray-400 text-3xl mb-4">Clipboard</div>
      <p className="text-gray-500 dark:text-gray-400 text-lg mb-2">No schedule data available</p>
      <p className="text-gray-400 dark:text-gray-500 text-sm">
        Your schedule will appear here when available
      </p>
    </div>
  )}
</div>


      {/* Optional: Show error notification if needed */}
      {error && (
        <div className="fixed top-4 right-4 bg-red-100 dark:bg-red-900 border border-red-400 dark:border-red-700 text-red-700 dark:text-red-300 px-4 py-3 rounded-lg shadow-lg z-50 max-w-sm">
          <div className="flex items-center">
            <div className="text-red-500 dark:text-red-400 mr-2">Warning</div>
            <span className="text-sm">{error}</span>
          </div>
          <button
            onClick={() => setError(null)}
            className="absolute top-2 right-2 text-red-500 dark:text-red-400 hover:text-red-700 dark:hover:text-red-300"
          >
            ×
          </button>
        </div>
      )}
    </div>
  );
};

export default InstructorDashboard;